const renderTestingComponent = (clientId: string): boolean => {
  return !['EVERIFY-externaltest', 'EVERIFY-preview', 'EVERIFY-prod'].includes(clientId);
};

const renderUatComponent = (clientId: string): boolean => {
  return !['EVERIFY-preview', 'EVERIFY-prod'].includes(clientId);
};

const renderPreProdComponent = (clientId: string): boolean => {
  return !['EVERIFY-prod'].includes(clientId);
};

export { renderTestingComponent, renderUatComponent, renderPreProdComponent };
